import Vue from "vue"
import Router from "vue-router"
import store from "./store"

import Login from "@/views/Login"
import Home from "@/views/Home"
import Dashboard from "@/views/dashboard/Dashboard"
import RegisterAccount from "@/views/RegisterAccount"
import ActivateAccount from "@/views/ActivateAccount"
import PasswordForgotten from "@/views/PasswordForgotten"
import ResetPassword from "@/views/ResetPassword"
import ActivateEmail from "@/views/ActivateEmail"
import Category from "@/views/dashboard/Category"
const DashboardIndex = () => import("@/views/dashboard/Index")
const MyAccount = () => import("@/views/dashboard/MyAccount")
const TrapUpsert = () => import("@/views/dashboard/TrapUpsert")
const Traps = () => import("@/views/dashboard/Traps")
const PlanList = () => import("@/views/dashboard/plan/PlanList")
const PlanView = () => import("@/views/dashboard/plan/PlanView")
const Stats = () => import("@/views/dashboard/Stats")
const GMap = () => import("@/views/dashboard/GMap")
import MagicLogin from "@/views/MagicLogin"
const PrivacyPolicy = () => import("@/views/PrivacyPolicy")

Vue.use(Router)

const router = new Router({
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        { path: "/", name: "home", component: Home },

        {
            path: "/login",
            name: "login",
            component: Login,
            meta: { noAuth: true },
        },
        {
            path: "/register",
            name: "register",
            component: RegisterAccount,
            meta: { noAuth: true },
        },
        {
            path: "/privacy-policy",
            name: "privacy-policy",
            component: PrivacyPolicy,
            meta: { noAuth: true },
        },
        {
            path: "/activate-account/:token",
            name: "activate-account",
            component: ActivateAccount,
            meta: { noAuth: true },
        },
        {
            path: "/magic-login/:token",
            name: "magic-login",
            component: MagicLogin,
            meta: { noAuth: true },
        },
        {
            path: "/activate-email/:token",
            name: "activate-email",
            component: ActivateEmail,
            meta: { noAuth: true },
        },
        {
            path: "/password-forgotten",
            name: "password-forgotten",
            component: PasswordForgotten,
            meta: { noAuth: true },
        },
        {
            path: "/reset-password/:token",
            name: "reset-password",
            component: ResetPassword,
            meta: { noAuth: true },
        },

        {
            path: "/dashboard/",
            component: Dashboard,
            children: [
                { path: "", name: "dashboard", component: DashboardIndex },
                {
                    path: "account",
                    name: "account",
                    component: MyAccount,
                },
                {
                    path: "categories",
                    name: "categories",
                    component: Category,
                    meta: { key: "categories-list", keepAlive: true },
                },
                {
                    path: "categories/:id",
                    name: "categories-id",
                    component: Category,
                    meta: { key: "categories-list", keepAlive: true },
                },
                {
                    path: "traps",
                    name: "traps",
                    component: Traps,
                    meta: { keepAlive: true },
                },
                {
                    path: "traps/:id/edit",
                    name: "trap-edit",
                    component: TrapUpsert,
                    meta: { keepAlive: false },
                },
                {
                    path: "new/traps",
                    name: "trap-new",
                    component: TrapUpsert,
                    meta: { keepAlive: false },
                },
                {
                    path: "plans",
                    name: "plans",
                    component: PlanList,
                    meta: { key: "plans-list", keepAlive: true },
                },
                {
                    path: "map",
                    name: "map",
                    component: GMap,
                    meta: { key: "map", keepAlive: true },
                },
                {
                    path: "plans/:id",
                    name: "plans-id",
                    component: PlanList,
                    meta: { key: "plans-list", keepAlive: true },
                },
                {
                    path: "plans/:id/view",
                    name: "plan-view",
                    component: PlanView,
                    meta: { key: "plans-map-view", keepAlive: true },
                },
                {
                    path: "stats",
                    name: "stats",
                    component: Stats,
                    meta: { key: "stats", keepAlive: true },
                },
            ],
        },
    ],
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => !record.meta.noAuth)) {
        if (!store.getters["user/logged"]) {
            next({ name: "login" })
            return
        }
    }
    if (
        store.getters["user/logged"] &&
        to.matched.some(record => {
            return record.name === "home" || record.name === "login"
        })
    ) {
        next({ name: "dashboard" })
        return
    }
    next()
})

export default router
